import { CompanyLifeCycleEvent } from "./model";
export function sortLifeCycleEvents(events) {
    return events.sort((a, b) => {
        if (a.date !== b.date) {
            return a.date < b.date ? -1 : 1;
        }
        return a.created.getTime() - b.created.getTime();
    });
}
// remove comments and employee names before giving data to customer
// TODO: this should return a DTO, not a model
// TODO: this should be in the CompanyLifeCycleEventService
export function removeInternalData(events) {
    return events.map((e) => new CompanyLifeCycleEvent({
        id: e.id,
        date: e.date,
        created: e.created,
        status: e.status,
    }));
}
//# sourceMappingURL=lifecycle-events.js.map